import { type ChangeEvent, useCallback, useEffect, useState } from 'react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import SearchIcon from '@/assets/icons/icon-search.svg'
import { TextField } from '@/components/ui/text-field.tsx'
import { Tooltip } from '@/components/ui/tooltip'
import { setCategoryQuery } from '@/models/vault/categories.ts'

const MIN_SEARCH_LENGTH = 2

export const VaultCategoriesSearch = () => {
  const [query, setQuery] = useState('')

  const isTooltipShown = !!query.length && query.length < MIN_SEARCH_LENGTH
  const resetQuery = useCallback(() => {
    setQuery('')
  }, [])

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value)
  }, [])

  useEffect(() => {
    if (!query || !isTooltipShown) {
      setCategoryQuery(query)
    }
  }, [isTooltipShown, query])

  return (
    <Tooltip
      content={
        isTooltipShown ? 'Type at least 2 characters to search' : undefined
      }
      open={isTooltipShown}
    >
      <TextField
        prefix={<SearchIcon />}
        suffix={
          query ? (
            <CloseIcon
              onClick={resetQuery}
              className="h-4 w-4 cursor-pointer hover:opacity-70"
            />
          ) : null
        }
        height={16}
        placeholder="Search"
        className="py-1"
        value={query}
        onChange={handleChange}
      />
    </Tooltip>
  )
}
